<template>
    <popup-modal-confirm
        :confirm-text="$t('general.add')"
        :has-close-button="true"
        :title="$t('applications.add_to_officient_subject', {subject: application.fullName})"
        :working="submitting"
        confirm-button="success"
        @close="$emit('close')"
        @confirm="submit"
    >
        <div class="w-full flex mt-24">
            <simple-input v-model="form.role" class="w-1/2 mr-16 autofocus">
                {{ $t('officient.position') }} ({{ $t('general.optional') }})
            </simple-input>

            <date-picker v-if="form.role" v-model="form.start_date" class="w-1/2 mr-16">{{ $t('officient.start_date') }}</date-picker>
        </div>
    </popup-modal-confirm>
</template>

<script>
import Application from '../../models/Application';
import PopupModal from './PopupModal.vue';
import Input from '../forms/Input.vue';
import {mapActions} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useNotificationsStore} from '../../state/modules/notifications';
import Form from '../../etc/forms/Form';
import DatePicker from '../forms/DatePicker.vue';
import SimpleButton from './SimpleButton.vue';
import * as applications from '../../services/ApplicationService';
import {ADD_NOTIFICATION} from '../../state/mutation-types';
import {normalizeJson} from '../../../shared/helpers';
import PopupModalConfirm from './PopupModalConfirm';


export default {
    components: {
        PopupModalConfirm,
        'popup-modal': PopupModal,
        'simple-button': SimpleButton,
        'simple-input': Input,
        'date-picker': DatePicker,
    },
    props: {
        application: Application,
    },
    data: function () {
        return {
            form: new Form([
                {name: 'role', value: ''},
                {name: 'start_date', value: null, accessor: value => value ? moment(value).format('YYYY-MM-DD') : null},
            ]),
            submitting: false,
            resultMessage: null,
        };
    },
    methods: {
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        submit() {
            this.submitting = true;

            if (this.form.data.start_date) {
                this.form.data.start_date = this.form.data.start_date.format('YYYY-MM-DD');
            } else {
                delete this.form.data.start_date;
            }

            this.form.submit(data => applications.addToOfficient(this.application.id, {
                data: {
                    attributes: data,
                },
            })).then((result) => {
                this.resultMessage = result;
                return applications.find(this.application.id);
            }).then(result => {
                useRepo(Application).save(normalizeJson(result));
            }).then(() => {
                this.submitting = false;
                let msg = {
                    type: 'success',
                    message: this.$t('officient.success'),
                };

                if (this.resultMessage) {
                    msg.message = this.resultMessage.variables ?
                        this.$t(this.resultMessage.message, this.resultMessage.variables) :
                        this.$t(this.resultMessage.message);
                }

                this[ADD_NOTIFICATION](msg);
                this.resultMessage = null;
            }).finally(() => {
                this.submitting = false;
                this.$emit('close');
            });
        },
    },
};
</script>
